import { UpdateCatalogViewPreferencesParams } from '../../../repositories/types/catalogs.repository.types';
import { CatalogViewCatalogField, CatalogViewDraft } from './catalogView.types';

const DRAFT_FIELD_TO_DTO_PATCH: Record<
  CatalogViewCatalogField,
  (draft: CatalogViewDraft) => UpdateCatalogViewPreferencesParams
> = {
  mode: (draft) => ({ viewMode: draft.mode }),
  cardSize: (draft) => ({ viewCardSize: draft.cardSize }),
  groupBy: (draft) => ({ viewGroupBy: draft.groupBy }),
  groupTargetId: (draft) => ({ viewGroupTargetId: draft.groupTargetId }),
  sortCriterion: (draft) => ({ sectionSortCriterion: draft.sortCriterion }),
  sortTargetId: (draft) => ({ sortTargetId: draft.sortTargetId }),
};

export const mapDraftToPatchDto = (
  dirtyForAll: CatalogViewCatalogField[],
  draft: CatalogViewDraft,
): UpdateCatalogViewPreferencesParams =>
  dirtyForAll.reduce<UpdateCatalogViewPreferencesParams>(
    (payload, field) => ({ ...payload, ...DRAFT_FIELD_TO_DTO_PATCH[field](draft) }),
    {},
  );
